/**
 * Sync calibration (docs/03 "Graph and delay compensation"). Two tap-along rounds:
 *   1. tap to clicks you hear  → audio reaction time + audio path latency
 *   2. tap to flashes you see  → visual reaction time + display latency
 * Reaction time cancels in the difference, leaving the audio-vs-picture offset.
 */

/** Median signed error (ms) between taps and the nearest stimulus, ignoring outliers. */
export function tapOffsetMs(stimuli: number[], taps: number[], periodMs: number): number | null {
  const errors: number[] = [];
  for (const tap of taps) {
    let best = Infinity;
    for (const s of stimuli) {
      const e = tap - s;
      if (Math.abs(e) < Math.abs(best)) best = e;
    }
    if (Math.abs(best) < periodMs * 0.45) errors.push(best);
  }
  if (errors.length < 4) return null;
  errors.sort((a, b) => a - b);
  return errors[Math.floor(errors.length / 2)]!;
}

/**
 * Display latency (ms) from the two rounds. Audio stimuli are timestamped at the moment the
 * browser reports they are heard, visual ones when the frame is handed to the compositor, so
 * once reaction time cancels, the difference is how long the picture takes to reach your eyes.
 */
export function displayLatencyFromRounds(audioMs: number, visualMs: number): number {
  return Math.round(Math.max(0, Math.min(150, visualMs - audioMs)));
}
